
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export const buildSalarySlipBreakdown = (payrollDetails) => {
  if (!payrollDetails) return null;

  const details = Array.isArray(payrollDetails.PayrollDetails)
    ? payrollDetails.PayrollDetails
    : [];

  const earnings = [];
  const deductions = [];

  details.filter((item) => {
    const active = item.HPD_IS_ACTIVE;

    return (
      active === undefined ||
      active === null ||
      active === "" ||
      active === true ||
      active === "True" ||
      active === "1" ||
      active === 1
    );
  })
  .forEach((item) => {
      const amount = round2(item.HPD_AMOUNT);

      if (!amount) return;

      const type = String(item.HPC_COMPONENT_TYPE || "").trim().toUpperCase();

      const label = item.HPD_DESCRIPTION || item.HPC_COMPONENT_NAME || "Payroll Component";

      // Extract sort params
      const sortOrder = parseInt(item.HPC_SORT_ORDER, 10) || 9999;
      const isBasic = String(item.HPC_COMPONENT_CODE).toUpperCase() === "BASIC" || String(item.HPC_IS_BASIC) === "True";

      if (type === "E") {
        earnings.push({
          label,
          amount,
          sortOrder,
          isBasic
        });
      } else if (type === "D") {
        deductions.push({
          label,
          amount,
          sortOrder
        })
      }
  });

  // Sort Earnings: Basic always first, then by sortOrder
  earnings.sort((a, b) => {
    if (a.isBasic && !b.isBasic) return -1;
    if (!a.isBasic && b.isBasic) return 1;
    return a.sortOrder - b.sortOrder;
  });

  // Sort Deductions: by sortOrder
  deductions.sort((a, b) => a.sortOrder - b.sortOrder);

  const totalEarnings = round2(payrollDetails.HPH_TOTAL_EARNINGS);
  const totalDeductions = round2(payrollDetails.HPH_TOTAL_DEDUCTIONS);
  const netSalary = round2(payrollDetails.HPH_NET_SALARY);

  return {
    earnings,
    deductions,
    totalEarnings,
    totalDeductions,
    netSalary,
  }
}
